// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TcXp{margin-top:1.6rem;padding:1.6rem 2rem}@media (min-width:62em){.TcXp{margin-top:0}}.j-lG{width:100%;margin:0 auto 1.6rem}._3VMR{display:block;margin:0 auto}._238d{text-align:center;flex:1}._238d .h5{margin:0}._238d .p2{margin:.8rem 0 0}._3yrr{min-width:24rem;min-height:0;margin:1.2rem auto 0;text-align:center;display:table}", ""]);
// Exports
exports.locals = {
	"item": "TcXp",
	"imgWrapp": "j-lG",
	"img": "_3VMR",
	"content": "_238d",
	"btn": "_3yrr"
};
module.exports = exports;
